'use client'

import { isSSR } from '@/lib/next/services/nextjs.rendering'
import { createContext, useContext } from 'react'

const AuthContext = createContext({ isAuthenticated: false, isPunchout: false })

type AuthContextProviderProps = {
  isAuthenticated: boolean
  isPunchout?: boolean
  children: React.ReactNode
}

export function AuthProvider({
  isAuthenticated,
  isPunchout = false,
  children,
}: AuthContextProviderProps): React.ReactNode {
  return (
    <AuthContext.Provider value={{ isAuthenticated, isPunchout }}>{children}</AuthContext.Provider>
  )
}

export function useIsAuthenticated(): boolean {
  const ctx = useContext(AuthContext)

  if (isSSR) {
    return ctx.isAuthenticated
  }

  if (!ctx) throw new Error('Missing AuthProvider')

  return ctx.isAuthenticated
}

export function useIsPunchout(): boolean {
  return useContext(AuthContext).isPunchout
}
